import { ref } from "vue"

export let icon_bar_status = ref<boolean>(false)
interface select {
    class: string,
    tag: string
}
interface icon {
    abbrivation: string, name: string
}
export let select_icon = ref<select>({
    class: '',
    tag: ''
})
export let fontawesome = ref<{ name: string }[]>([
    { name: "fa-solid fa-house", },
    { name: "fa-regular fa-user", },
    { name: "fa-brands fa-facebook", },
    { name: "fa-solid fa-check", },
    { name: "fa-solid fa-download", },
    { name: "fa-brands fa-twitter", },
    { name: "fa-solid fa-image", },
    { name: "fa-regular fa-image", },
    { name: "fa-solid fa-phone", },
    { name: "fa-brands fa-tiktok", },
    { name: "fa-solid fa-bars", },
    { name: "fa-regular fa-envelope", },
    { name: "fa-solid fa-envelope", },
    { name: "fa-brands fa-linkedin", },
    { name: "fa-solid fa-star", },
    { name: "fa-solid fa-location", },
    { name: "fa-brands fa-github", },
    { name: "fa-solid fa-music", },
    { name: "fa-solid fa-users", },
    { name: "fa-solid fa-heart", },
    { name: "fa-regular fa-heart", },
    { name: "fa-solid fa-arrow-right", },
    { name: "fa-brands fa-discord", },
    { name: "fa-solid fa-circle", },
    { name: "fa-solid fa-bomb", },
    { name: "fa-solid fa-poo", },
    { name: "fa-brands fa-youtube", },
    { name: "fa-solid fa-cloud", },
    { name: "fa-solid fa-comment", },
    { name: "fa-regular fa-comment", },
    { name: "fa-solid fa-caret-up", },
    { name: "fa-solid fa-truck", },
    { name: "fa-brands fa-wordpress", },
    { name: "fa-solid fa-pen-nib", },
    { name: "fa-solid fa-arrow-up", },
    { name: "fa-solid fa-hippo", },
    { name: "fa-solid fa-face-smile", },
    { name: "fa-regular fa-face-smile", },
    { name: "fa-solid fa-calendar", },
    { name: "fa-regular fa-calendar", },
    { name: "fa-solid fa-paperclip", },
    { name: "fa-brands fa-slack", },
    { name: "fa-solid fa-shield-halved", },
    { name: "fa-brands fa-figma", },
    { name: "fa-regular fa-file", },
    { name: "fa-solid fa-bell", },
    { name: "fa-regular fa-bell", },
    { name: "fa-solid fa-cart-shopping", },
    { name: "fa-solid fa-clipboard", },
    { name: "fa-regular fa-clipboard", },
    { name: "fa-solid fa-filter", },
    { name: "fa-solid fa-circle-info", },
    { name: "fa-solid fa-bolt", },
    { name: "fa-solid fa-car", },
    { name: "fa-solid fa-ghost", },
    { name: "fa-brands fa-apple", },
    { name: "fa-solid fa-mug-hot", },
    { name: "fa-solid fa-circle-user", },
    { name: "fa-regular fa-circle-user", },
    { name: "fa-solid fa-pen", },
    { name: "fa-regular fa-circle-user", },
    { name: "fa-brands fa-google", },
    { name: "fa-solid fa-umbrella", },
    { name: "fa-solid fa-gift", },
    { name: "fa-solid fa-film", },
    { name: "fa-solid fa-list", },
    { name: "fa-solid fa-gear", },
    { name: "fa-solid fa-backward", },
    { name: "fa-solid fa-trash", },
    { name: "fa-solid fa-circle-up", },
    { name: "fa-regular fa-circle-up", },
    { name: "fa-brands fa-docker", },
    { name: "fa-solid fa-circle-down", },
    { name: "fa-regular fa-circle-down", },
    { name: "fa-solid fa-inbox", },
    { name: "fa-solid fa-rotate-right", },
    { name: "fa-solid fa-lock", },
    { name: "fa-solid fa-info", },
    { name: "fa-solid fa-headphones", },
    { name: "fa-solid fa-barcode", },
    { name: "fa-solid fa-book", },
    { name: "fa-solid fa-bookmark", },
    { name: "fa-brands fa-paypal", },
    { name: "fa-solid fa-print", },
    { name: "fa-solid fa-camera", },
    { name: "fa-solid fa-caret-down", },
    { name: "fa-solid fa-font", },
    { name: "fa-solid fa-video", },
    { name: "fa-solid fa-circle-half-stroke", },
    { name: "fa-solid fa-droplet", },
    { name: "fa-solid fa-pen-to-square", },
    { name: "fa-regular fa-pen-to-square", },
    { name: "fa-solid fa-share-from-square", },
    { name: "fa-regular fa-pen-to-square", },
    { name: "fa-solid fa-plus", },
    { name: "fa-solid fa-minus", },
    { name: "fa-solid fa-share", },
    { name: "fa-solid fa-circle-exclamation", },
    { name: "fa-solid fa-fire", },
    { name: "fa-solid fa-eye-slash", },
    { name: "fa-regular fa-eye", },
    { name: "fa-solid fa-eye", },
    { name: "fa-regular fa-eye", },
    { name: "fa-solid fa-scroll", },
    { name: "fa-solid fa-plane", },
    { name: "fa-solid fa-folder", },
    { name: "fa-solid fa-thumbs-up", },
    { name: "fa-regular fa-thumbs-up", },
    { name: "fa-solid fa-thumbs-down", },
    { name: "fa-regular fa-thumbs-down", },
    { name: "fa-solid fa-comments", },
    { name: "fa-solid fa-key", },
    { name: "fa-solid fa-thumbtack", },
    { name: "fa-solid fa-gears", },
    { name: "fa-solid fa-paper-plane", },
    { name: "fa-solid fa-person", },
    { name: "fa-solid fa-wifi", },
    { name: "fa-solid fa-right-to-bracket", },
    { name: "fa-solid fa-gear", },
    { name: "fa-solid fa-cloud-arrow-up", },
    { name: "fa-solid fa-xmark", },
]
)
export let feather_icons = ref<icon[]>([
    { abbrivation: 'activity', name: 'activity' },
    { abbrivation: 'airplay', name: 'airplay' },
    { abbrivation: 'alert-circle', name: 'alert-circle' },
    { abbrivation: 'alert-octagon', name: 'alert-octagon' },
    { abbrivation: 'alert-triangle', name: 'alert-triangle' },
    { abbrivation: 'align-center', name: 'align-center' },
    { abbrivation: 'align-justify', name: 'align-justify' },
    { abbrivation: 'align-left', name: 'align-left' },
    { abbrivation: 'align-right', name: 'align-right' },
    { abbrivation: 'anchor', name: 'anchor' },
    { abbrivation: 'aperture', name: 'aperture' },
    { abbrivation: 'archive', name: 'archive' },
    { abbrivation: 'arrow-down-circle', name: 'arrow-down-circle' },
    { abbrivation: 'arrow-down-left', name: 'arrow-down-left' },
    { abbrivation: 'arrow-down-right', name: 'arrow-down-right' },
    { abbrivation: 'arrow-down', name: 'arrow-down' },
    { abbrivation: 'arrow-left-circle', name: 'arrow-left-circle' },
    { abbrivation: 'arrow-left', name: 'arrow-left' },
    { abbrivation: 'arrow-right-circle', name: 'arrow-right-circle' },
    { abbrivation: 'arrow-right', name: 'arrow-right' },
    { abbrivation: 'arrow-up-circle', name: 'arrow-up-circle' },
    { abbrivation: 'arrow-up-left', name: 'arrow-up-left' },
    { abbrivation: 'arrow-up-right', name: 'arrow-up-right' },
    { abbrivation: 'arrow-up', name: 'arrow-up' },
    { abbrivation: 'at-sign', name: 'at-sign' },
    { abbrivation: 'award', name: 'award' },
    { abbrivation: 'bar-chart-2', name: 'bar-chart-2' },
    { abbrivation: 'bar-chart', name: 'bar-chart' },
    { abbrivation: 'battery-charging', name: 'battery-charging' },
    { abbrivation: 'battery', name: 'battery' },
    { abbrivation: 'bell-off', name: 'bell-off' },
    { abbrivation: 'bell', name: 'bell' },
    { abbrivation: 'bluetooth', name: 'bluetooth' },
    { abbrivation: 'bold', name: 'bold' },
    { abbrivation: 'book-open', name: 'book-open' },
    { abbrivation: 'book', name: 'book' },
    { abbrivation: 'bookmark', name: 'bookmark' },
    { abbrivation: 'box', name: 'box' },
    { abbrivation: 'briefcase', name: 'briefcase' },
    { abbrivation: 'calendar', name: 'calendar' },
    { abbrivation: 'camera-off', name: 'camera-off' },
    { abbrivation: 'camera', name: 'camera' },
    { abbrivation: 'cast', name: 'cast' },
    { abbrivation: 'check-circle', name: 'check-circle' },
    { abbrivation: 'check-square', name: 'check-square' },
    { abbrivation: 'check', name: 'check' },
    { abbrivation: 'chevron-down', name: 'chevron-down' },
    { abbrivation: 'chevron-left', name: 'chevron-left' },
    { abbrivation: 'chevron-right', name: 'chevron-right' },
    { abbrivation: 'chevron-up', name: 'chevron-up' },
    { abbrivation: 'chevrons-down', name: 'chevrons-down' },
    { abbrivation: 'chevrons-left', name: 'chevrons-left' },
    { abbrivation: 'chevrons-right', name: 'chevrons-right' },
    { abbrivation: 'chevrons-up', name: 'chevrons-up' },
    { abbrivation: 'chrome', name: 'chrome' },
    { abbrivation: 'circle', name: 'circle' },
    { abbrivation: 'clipboard', name: 'clipboard' },
    { abbrivation: 'clock', name: 'clock' },
    { abbrivation: 'cloud-drizzle', name: 'cloud-drizzle' },
    { abbrivation: 'cloud-lightning', name: 'cloud-lightning' },
    { abbrivation: 'cloud-off', name: 'cloud-off' },
    { abbrivation: 'cloud-rain', name: 'cloud-rain' },
    { abbrivation: 'cloud-snow', name: 'cloud-snow' },
    { abbrivation: 'cloud', name: 'cloud' },
    { abbrivation: 'code', name: 'code' },
    { abbrivation: 'codepen', name: 'codepen' },
    { abbrivation: 'coffee', name: 'coffee' },
    { abbrivation: 'command', name: 'command' },
    { abbrivation: 'compass', name: 'compass' },
    { abbrivation: 'copy', name: 'copy' },
    { abbrivation: 'corner-down-left', name: 'corner-down-left' },
    { abbrivation: 'corner-down-right', name: 'corner-down-right' },
    { abbrivation: 'corner-left-down', name: 'corner-left-down' },
    { abbrivation: 'corner-left-up', name: 'corner-left-up' },
    { abbrivation: 'corner-right-down', name: 'corner-right-down' },
    { abbrivation: 'corner-right-up', name: 'corner-right-up' },
    { abbrivation: 'corner-up-left', name: 'corner-up-left' },
    { abbrivation: 'corner-up-right', name: 'corner-up-right' },
    { abbrivation: 'cpu', name: 'cpu' },
    { abbrivation: 'credit-card', name: 'credit-card' },
    { abbrivation: 'crop', name: 'crop' },
    { abbrivation: 'crosshair', name: 'crosshair' },
    { abbrivation: 'database', name: 'database' },
    { abbrivation: 'delete', name: 'delete' },
    { abbrivation: 'disc', name: 'disc' },
    { abbrivation: 'dollar-sign', name: 'dollar-sign' },
    { abbrivation: 'download-cloud', name: 'download-cloud' },
    { abbrivation: 'download', name: 'download' },
    { abbrivation: 'droplet', name: 'droplet' },
    { abbrivation: 'edit-2', name: 'edit-2' },
    { abbrivation: 'edit-3', name: 'edit-3' },
    { abbrivation: 'edit', name: 'edit' },
    { abbrivation: 'external-link', name: 'external-link' },
    { abbrivation: 'eye-off', name: 'eye-off' },
    { abbrivation: 'eye', name: 'eye' },
    { abbrivation: 'facebook', name: 'facebook' },
    { abbrivation: 'fast-forward', name: 'fast-forward' },
    { abbrivation: 'feather', name: 'feather' },
    { abbrivation: 'file-minus', name: 'file-minus' },
    { abbrivation: 'file-plus', name: 'file-plus' },
    { abbrivation: 'file-text', name: 'file-text' },
    { abbrivation: 'file', name: 'file' },
    { abbrivation: 'film', name: 'film' },
    { abbrivation: 'filter', name: 'filter' },
    { abbrivation: 'flag', name: 'flag' },
    { abbrivation: 'folder-minus', name: 'folder-minus' },
    { abbrivation: 'folder-plus', name: 'folder-plus' },
    { abbrivation: 'folder', name: 'folder' },
    { abbrivation: 'gift', name: 'gift' },
    { abbrivation: 'git-branch', name: 'git-branch' },
    { abbrivation: 'git-commit', name: 'git-commit' },
    { abbrivation: 'git-merge', name: 'git-merge' },
    { abbrivation: 'git-pull-request', name: 'git-pull-request' },
    { abbrivation: 'github', name: 'github' },
    { abbrivation: 'gitlab', name: 'gitlab' },
    { abbrivation: 'globe', name: 'globe' },
    { abbrivation: 'grid', name: 'grid' },
    { abbrivation: 'hard-drive', name: 'hard-drive' },
    { abbrivation: 'hash', name: 'hash' },
    { abbrivation: 'headphones', name: 'headphones' },
    { abbrivation: 'heart', name: 'heart' },
    { abbrivation: 'help-circle', name: 'help-circle' },
    { abbrivation: 'home', name: 'home' },
    { abbrivation: 'image', name: 'image' },
    { abbrivation: 'inbox', name: 'inbox' },
    { abbrivation: 'info', name: 'info' },
    { abbrivation: 'instagram', name: 'instagram' },
    { abbrivation: 'italic', name: 'italic' },
    { abbrivation: 'layers', name: 'layers' },
    { abbrivation: 'layout', name: 'layout' },
    { abbrivation: 'life-buoy', name: 'life-buoy' },
    { abbrivation: 'link-2', name: 'link-2' },
    { abbrivation: 'link', name: 'link' },
    { abbrivation: 'linkedin', name: 'linkedin' },
    { abbrivation: 'list', name: 'list' },
    { abbrivation: 'loader', name: 'loader' },
    { abbrivation: 'lock', name: 'lock' },
    { abbrivation: 'log-in', name: 'log-in' },
    { abbrivation: 'log-out', name: 'log-out' },
    { abbrivation: 'mail', name: 'mail' },
    { abbrivation: 'map-pin', name: 'map-pin' },
    { abbrivation: 'map', name: 'map' },
    { abbrivation: 'maximize-2', name: 'maximize-2' },
    { abbrivation: 'maximize', name: 'maximize' },
    { abbrivation: 'menu', name: 'menu' },
    { abbrivation: 'message-circle', name: 'message-circle' },
    { abbrivation: 'message-square', name: 'message-square' },
    { abbrivation: 'mic-off', name: 'mic-off' },
    { abbrivation: 'mic', name: 'mic' },
    { abbrivation: 'minimize-2', name: 'minimize-2' },
    { abbrivation: 'minimize', name: 'minimize' },
    { abbrivation: 'minus-circle', name: 'minus-circle' },
    { abbrivation: 'minus-square', name: 'minus-square' },
    { abbrivation: 'minus', name: 'minus' },
    { abbrivation: 'monitor', name: 'monitor' },
    { abbrivation: 'moon', name: 'moon' },
    { abbrivation: 'more-horizontal', name: 'more-horizontal' },
    { abbrivation: 'more-vertical', name: 'more-vertical' },
    { abbrivation: 'move', name: 'move' },
    { abbrivation: 'music', name: 'music' },
    { abbrivation: 'navigation-2', name: 'navigation-2' },
    { abbrivation: 'navigation', name: 'navigation' },
    { abbrivation: 'octagon', name: 'octagon' },
    { abbrivation: 'package', name: 'package' },
    { abbrivation: 'paperclip', name: 'paperclip' },
    { abbrivation: 'pause-circle', name: 'pause-circle' },
    { abbrivation: 'pause', name: 'pause' },
    { abbrivation: 'percent', name: 'percent' },
    { abbrivation: 'phone-call', name: 'phone-call' },
    { abbrivation: 'phone-forwarded', name: 'phone-forwarded' },
    { abbrivation: 'phone-incoming', name: 'phone-incoming' },
    { abbrivation: 'phone-missed', name: 'phone-missed' },
    { abbrivation: 'phone-off', name: 'phone-off' },
    { abbrivation: 'phone-outgoing', name: 'phone-outgoing' },
    { abbrivation: 'phone', name: 'phone' },
    { abbrivation: 'pie-chart', name: 'pie-chart' },
    { abbrivation: 'play-circle', name: 'play-circle' },
    { abbrivation: 'play', name: 'play' },
    { abbrivation: 'plus-circle', name: 'plus-circle' },
    { abbrivation: 'plus-square', name: 'plus-square' },
    { abbrivation: 'plus', name: 'plus' },
    { abbrivation: 'pocket', name: 'pocket' },
    { abbrivation: 'power', name: 'power' },
    { abbrivation: 'printer', name: 'printer' },
    { abbrivation: 'radio', name: 'radio' },
    { abbrivation: 'refresh-ccw', name: 'refresh-ccw' },
    { abbrivation: 'refresh-cw', name: 'refresh-cw' },
    { abbrivation: 'repeat', name: 'repeat' },
    { abbrivation: 'rewind', name: 'rewind' },
    { abbrivation: 'rotate-ccw', name: 'rotate-ccw' },
    { abbrivation: 'rotate-cw', name: 'rotate-cw' },
    { abbrivation: 'rss', name: 'rss' },
    { abbrivation: 'save', name: 'save' },
    { abbrivation: 'scissors', name: 'scissors' },
    { abbrivation: 'search', name: 'search' },
    { abbrivation: 'send', name: 'send' },
    { abbrivation: 'server', name: 'server' },
    { abbrivation: 'settings', name: 'settings' },
    { abbrivation: 'share-2', name: 'share-2' },
    { abbrivation: 'share', name: 'share' },
    { abbrivation: 'shield-off', name: 'shield-off' },
    { abbrivation: 'shield', name: 'shield' },
    { abbrivation: 'shopping-bag', name: 'shopping-bag' },
    { abbrivation: 'shopping-cart', name: 'shopping-cart' },
    { abbrivation: 'shuffle', name: 'shuffle' },
    { abbrivation: 'sidebar', name: 'sidebar' },
    { abbrivation: 'skip-back', name: 'skip-back' },
    { abbrivation: 'skip-forward', name: 'skip-forward' },
    { abbrivation: 'slack', name: 'slack' },
    { abbrivation: 'slash', name: 'slash' },
    { abbrivation: 'sliders', name: 'sliders' },
    { abbrivation: 'smartphone', name: 'smartphone' },
    { abbrivation: 'speaker', name: 'speaker' },
    { abbrivation: 'square', name: 'square' },
    { abbrivation: 'star', name: 'star' },
    { abbrivation: 'stop-circle', name: 'stop-circle' },
    { abbrivation: 'sun', name: 'sun' },
    { abbrivation: 'sunrise', name: 'sunrise' },
    { abbrivation: 'sunset', name: 'sunset' },
    { abbrivation: 'tablet', name: 'tablet' },
    { abbrivation: 'tag', name: 'tag' },
    { abbrivation: 'target', name: 'target' },
    { abbrivation: 'terminal', name: 'terminal' },
    { abbrivation: 'thermometer', name: 'thermometer' },
    { abbrivation: 'thumbs-down', name: 'thumbs-down' },
    { abbrivation: 'thumbs-up', name: 'thumbs-up' },
    { abbrivation: 'toggle-left', name: 'toggle-left' },
    { abbrivation: 'toggle-right', name: 'toggle-right' },
    { abbrivation: 'trash-2', name: 'trash-2' },
    { abbrivation: 'trash', name: 'trash' },
    { abbrivation: 'trending-down', name: 'trending-down' },
    { abbrivation: 'trending-up', name: 'trending-up' },
    { abbrivation: 'triangle', name: 'triangle' },
    { abbrivation: 'truck', name: 'truck' },
    { abbrivation: 'tv', name: 'tv' },
    { abbrivation: 'twitter', name: 'twitter' },
    { abbrivation: 'type', name: 'type' },
    { abbrivation: 'umbrella', name: 'umbrella' },
    { abbrivation: 'underline', name: 'underline' },
    { abbrivation: 'unlock', name: 'unlock' },
    { abbrivation: 'upload-cloud', name: 'upload-cloud' },
    { abbrivation: 'upload', name: 'upload' },
    { abbrivation: 'user-check', name: 'user-check' },
    { abbrivation: 'user-minus', name: 'user-minus' },
    { abbrivation: 'user-plus', name: 'user-plus' },
    { abbrivation: 'user-x', name: 'user-x' },
    { abbrivation: 'user', name: 'user' },
    { abbrivation: 'users', name: 'users' },
    { abbrivation: 'video-off', name: 'video-off' },
    { abbrivation: 'video', name: 'video' },
    { abbrivation: 'voicemail', name: 'voicemail' },
    { abbrivation: 'volume-1', name: 'volume-1' },
    { abbrivation: 'volume-2', name: 'volume-2' },
    { abbrivation: 'volume-x', name: 'volume-x' },
    { abbrivation: 'volume', name: 'volume' },
    { abbrivation: 'watch', name: 'watch' },
    { abbrivation: 'wifi-off', name: 'wifi-off' },
    { abbrivation: 'wifi', name: 'wifi' },
    { abbrivation: 'wind', name: 'wind' },
    { abbrivation: 'x-circle', name: 'x-circle' },
    { abbrivation: 'x-square', name: 'x-square' },
    { abbrivation: 'x', name: 'x' },
    { abbrivation: 'youtube', name: 'youtube' },
    { abbrivation: 'zap-off', name: 'zap-off' },
    { abbrivation: 'zap', name: 'zap' },
    { abbrivation: 'zoom-in', name: 'zoom-in' },
    { abbrivation: 'zoom-out', name: 'zoom-out' },
])
export let lconly = ref<{ name: string, title: string }[]>([
    { name: "iconly-Activity icli", title: "Activity " },
    { name: "iconly-Add-User icli", title: "Add-User " },
    { name: "iconly-Arrow-Down icli", title: "Arrow-Down " },
    { name: "iconly-Arrow-Down-2 icli", title: "Arrow-Down-2" },
    { name: "iconly-Arrow-Down-3 icli", title: "Arrow-Down-3" },
    { name: "iconly-Arrow-Down-Circle icli", title: "Arrow-Down-Circle" },
    { name: "iconly-Arrow-Down-Square icli", title: "Arrow-Down-Square" },
    { name: "iconly-Arrow-Left icli", title: "Arrow-Left " },
    { name: "iconly-Arrow-Left-2 icli", title: "Arrow-Left-2" },
    { name: "iconly-Arrow-Left-3 icli", title: "Arrow-Left-3" },
    { name: "iconly-Arrow-Left-Circle icli", title: "Arrow-Left-Circle" },
    { name: "iconly-Arrow-Left-Square icli", title: "Arrow-Left-Square" },
    { name: "iconly-Arrow-Right icli", title: "Arrow-Right " },
    { name: "iconly-Arrow-Right-2 icli", title: "Arrow-Right-2" },
    { name: "iconly-Arrow-Right-3 icli", title: "Arrow-Right-3" },
    { name: "iconly-Arrow-Right-Circle icli", title: "Arrow-Right-Circle" },
    { name: "iconly-Arrow-Up icli", title: "Arrow-Up " },
    { name: "iconly-Arrow-Up-2 icli", title: "Arrow-Up-2" },
    { name: "iconly-Arrow-Up-3 icli", title: "Arrow-Up-3" },
    { name: "iconly-Arrow-Up-Circle icli", title: "Arrow-Up-Circle" },
    { name: "iconly-Bag icli", title: "Bag " },
    { name: "iconly-Bag-2 icli", title: "Bag-2 " },
    { name: "iconly-Bookmark icli", title: "Bookmark " },
    { name: "iconly-Buy icli", title: "Buy " },
    { name: "iconly-Calendar icli", title: "Calendar " },
    { name: "iconly-Call icli", title: "Call " },
    { name: "iconly-Call-Missed icli", title: "Call-Missed " },
    { name: "iconly-Call-Silent icli", title: "Call-Silent " },
    { name: "iconly-Calling icli", title: "Calling " },
    { name: "iconly-Camera icli", title: "Camera " },
    { name: "iconly-Category icli", title: "Category " },
    { name: "iconly-Chart icli", title: "Chart " },
    { name: "iconly-Chat icli", title: "Chat " },
    { name: "iconly-Close-Square icli", title: "Close-Square " },
    { name: "iconly-Danger icli", title: "Danger " },
    { name: "iconly-Delete icli", title: "Delete " },
    { name: "iconly-Discount icli", title: "Discount " },
    { name: "iconly-Discovery icli", title: "Discovery " },
    { name: "iconly-Document icli", title: "Document " },
    { name: "iconly-Download icli", title: "Download " },
    { name: "iconly-Edit icli", title: "Edit " },
    { name: "iconly-Edit-Square icli", title: "Edit-Square " },
    { name: "iconly-Filter icli", title: "Filter " },
    { name: "iconly-Filter-2 icli", title: "Filter-2 " },
    { name: "iconly-Folder icli", title: "Folder " },
    { name: "iconly-Game icli", title: "Game " },
    { name: "iconly-Graph icli", title: "Graph " },
    { name: "iconly-Heart icli", title: "Heart " },
    { name: "iconly-Hide icli", title: "Hide " },
    { name: "iconly-Home icli", title: "Home " },
    { name: "iconly-Image icli", title: "Image " },
    { name: "iconly-Image-2 icli", title: "Image-2 " },
    { name: "iconly-Info-Circle icli", title: "Info-Circle " },
    { name: "iconly-Info-Square icli", title: "Info-Square " },
    { name: "iconly-Location icli", title: "Location " },
    { name: "iconly-Lock icli", title: "Lock " },
    { name: "iconly-Login icli", title: "Login " },
    { name: "iconly-Logout icli", title: "Logout " },
    { name: "iconly-Message icli", title: "Message " },
    { name: "iconly-More-Circle icli", title: "More-Circle " },
    { name: "iconly-More-Square icli", title: "More-Square " },
    { name: "iconly-Notification icli", title: "Notification " },
    { name: "iconly-Paper icli", title: "Paper " },
    { name: "iconly-Paper-Download icli", title: "Paper-Download " },
    { name: "iconly-Paper-Fail icli", title: "Paper-Fail " },
    { name: "iconly-Paper-Negative icli", title: "Paper-Negative " },
    { name: "iconly-Paper-Plus icli", title: "Paper-Plus " },
    { name: "iconly-Paper-Upload icli", title: "Paper-Upload " },
    { name: "iconly-Password icli", title: "Password " },
    { name: "iconly-Play icli", title: "Play " },
    { name: "iconly-Plus icli", title: "Plus " },
    { name: "iconly-Profile icli", title: "Profile " },
    { name: "iconly-Scan icli", title: "Scan " },
    { name: "iconly-Search icli", title: "Search " },
    { name: "iconly-Send icli", title: "Send " },
    { name: "iconly-Setting icli", title: "Setting " },
    { name: "iconly-Shield-Done icli", title: "Shield-Done " },
    { name: "iconly-Shield-Fail icli", title: "Shield-Fail " },
    { name: "iconly-Show icli", title: "Show " },
    { name: "iconly-Star icli", title: "Star " },
    { name: "iconly-Swap icli", title: "Swap " },
    { name: "iconly-Tick-Square icli", title: "Tick-Square " },
    { name: "iconly-Ticket icli", title: "Ticket " },
    { name: "iconly-Ticket-Star icli", title: "Ticket-Star " },
    { name: "iconly-Time-Circle icli", title: "Time-Circle " },
    { name: "iconly-Time-Square icli", title: "Time-Square " },
    { name: "iconly-Unlock icli", title: "Unlock " },
    { name: "iconly-Upload icli", title: "Upload " },
    { name: "iconly-User2 icli", title: "User2 " },
    { name: "iconly-User3 icli", title: "User3 " },
    { name: "iconly-Video icli", title: "Video " },
    { name: "iconly-Voice icli", title: "Voice " },
    { name: "iconly-Voice-2 icli", title: "Voice-2 " },
    { name: "iconly-Volume-Down icli", title: "Volume-Down " },
    { name: "iconly-Volume-Off icli", title: "Volume-Off " },

])